import Translate from "../../../components/Translate";
import {Link} from "react-router-dom";
import React, {Fragment} from "react";

export default function MenuConfigura({
                                          isRuoloAdmin,
                                          isRuoloSegreteria,
                                      }) {

    return (isRuoloAdmin() || isRuoloSegreteria()) &&
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="utenti-menu"
               role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-cogs"/> <Translate>Configura</Translate>
            </a>
            <ul className="dropdown-menu" aria-labelledby="utenti-menu">
                <li>
                    <Link to="/conf-utenti" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-user-alt"/>
                            <Translate>Utenti</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li>
                    <Link to="/list-club" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-users"/>
                            <Translate>Club</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-agenzie" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-users"/>
                            <Translate>Agenzie</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-titoli" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-tag"/>
                            <Translate>Titoli</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-tipi-socio" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-user-tag"/>
                            <Translate>Tipi di Socio</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li>
                    <Link to="/list-registri-veic" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-folder"/>
                            <Translate>Registri di Veicoli</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-tipi-carr" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-car"/>
                            <Translate>Tipi Carrozzeria</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-colori" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-palette"/>
                            <Translate>Colori</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li>
                    <Link to="/list-modalita-pag"
                          className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-money-check-alt"/>
                            <Translate>Modalità di Pagamento</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-conti" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-hand-holding-usd"/>
                            <Translate>Conti</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-tipi-mov" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-exchange-alt"></i>
                            <Translate>Tipi Movimenti</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-cat-causali"
                          className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-tags"/>
                            <Translate>Categorie Causali</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-causali-mov"
                          className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-stream"/>
                            <Translate>Causali Movimenti</Translate>
                        </div>
                    </Link>
                </li>
                {
                    isRuoloAdmin() &&
                    <Fragment>
                        <li>
                            <hr className="dropdown-divider"/>
                        </li>
                        <li>
                            <Link to="/conf-parametri"
                                  className="dropdown-item">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-sliders"/>
                                    <Translate>Impostazioni</Translate>
                                </div>
                            </Link>
                        </li>
                    </Fragment>
                }
            </ul>
        </li>
}